import { componentName, ButtonSelectionGroupClass } from './ButtonSelectionGroupClass';
import '../descope-button-selection-group-internal';
import '../descope-button-selection-group-item';

customElements.define(componentName, ButtonSelectionGroupClass);

export { ButtonSelectionGroupClass, componentName };
